import { extractPhoneDigits } from "@pro-sto/ui";

export function toHelpPhoneDigits(raw: string): string {
  return extractPhoneDigits(raw).slice(0, 10);
}

export function toStoredHelpPhone(raw: string): string {
  const digits = toHelpPhoneDigits(raw);
  return digits.length > 0 ? `+7${digits}` : "";
}

export function formatHelpPhone(digits: string): string {
  if (!digits) return "";
  if (digits.length <= 3) return `+7 (${digits}`;
  if (digits.length <= 6) return `+7 (${digits.slice(0, 3)}) ${digits.slice(3)}`;
  if (digits.length <= 8) {
    return `+7 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return `+7 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`;
}
